import { MouseEventHandler } from 'react'
import { Box } from 'theme-ui'
import { GooglePlaceSearchResults } from 'types/location'

export type GooglePlacesListItemProps = {
  item: GooglePlaceSearchResults
  onClick: MouseEventHandler
}

export const GooglePlacesListItem = ({
  item,
  onClick,
}: GooglePlacesListItemProps) => {
  return (
    <Box variant="layout.result.locationSearch" onClick={onClick} sx={{}}>
      {item.description}
    </Box>
  )
}
